// extracted by mini-css-extract-plugin
module.exports = {"label":"DateRange__label___ZsOO4","termInputLabel":"DateRange__termInputLabel___3gcBM","calendar_container":"DateRange__calendar_container___1VejC"};